// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"video-popup-module--backdrop--1r94P","in":"video-popup-module--in--35IzK","container":"video-popup-module--container--2kBnb","close":"video-popup-module--close--2gz9r"};